<template>
  <a-card title="Profile Karyawan">
    <a-button slot="extra" @click="handleModalEdit()">Ubah Data</a-button>
    <a-row :gutter="16">
      <a-alert
        v-if="data.profile.notif_wa == '1'"
        class="m-bottom"
        message="Anda bersedia menerima pesan notifikasi melalui whatsapp."
      >
      </a-alert>
      <a-col :xs="{ span: 24 }" :lg="{ span: 14 }">
        <div class="m-bottom">
          <h4 class="m-remove">Nama Pegawai</h4>
          <span class="m-text-light">{{ data.profile.nama }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">N.I.K</h4>
          <span class="m-text-light">{{ data.profile.nik }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No. KTP</h4>
          <span class="m-text-light">{{ data.profile.no_ktp }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">E-Mail Korporat</h4>
          <span class="m-text-light">{{ data.profile.email }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">E-Mail Pribadi</h4>
          <span class="m-text-light">{{ data.profile.gmail ? data.profile.gmail : '-' }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Status Perkawinan</h4>
          <span class="m-text-light">{{ data.profile.status_perkawinan }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Alamat</h4>
          <span class="m-text-light">{{ data.profile.alamat }}</span>
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
        <div class="m-bottom">
          <h4 class="m-remove">TLC</h4>
          <span class="m-text-light">{{ data.profile.tlc }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Agama</h4>
          <span class="m-text-light">{{ data.profile.agama }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Tempat, Tanggal Lahir</h4>
          <span class="m-text-light">{{ data.profile.ttl + " (" + data.profile.umur + ")" }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No. Telpon</h4>
          <span class="m-text-light">{{ formatNumberTelp() }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No. Whatsapp</h4>
          <span class="m-text-light">
            {{ formatNumberWA() }}
          </span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Tanggungan</h4>
          <span class="m-text-light">
            {{ data.profile.tanggungan ? data.profile.tanggungan : "-" }}
          </span>
        </div>
      </a-col>
    </a-row>

    <a-modal
      :width="800"
      title="Edit Data Kepegawaian"
      :visible="visible"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="btnLoading"
          @click="handleOk"
          >Submit</a-button
        >
      </template>
      <a-form class="m-form" :form="form">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="NIK">
              <a-input
                :disabled="getAuth.divisi[0] !== 'HRD'"
                autocomplete="off"
                v-decorator="['nik', { initialValue: data.profile.nik }]"
              />
            </a-form-item>
            <a-form-item label="TLC">
              <a-input
                disabled
                autocomplete="off"
                v-decorator="[
                  'tlc',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.tlc,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Nama Lengkap">
              <a-input
                :disabled="getAuth.divisi[0] !== 'HRD'"
                autocomplete="off"
                v-decorator="[
                  'nama',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.nama,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="No. Ktp">
               
              <a-input
              :disabled="getAuth.divisi[0] !== 'HRD'"
                autocomplete="off"
                v-decorator="[
                  'no_ktp',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.no_ktp,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Alamat">
              <a-textarea
                :rows="1"
                v-decorator="[
                  'alamat',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.alamat,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="No. Telp">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'noTelp',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.no_telp,
                  },
                ]"
              >
                <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'noTelp_code',
                    {
                      initialValue:
                        data.profile.country_code_tlp == null
                          ? '62'
                          : data.profile.country_code_tlp,
                    },
                  ]"
                  style="width: 70px"
                >
                  <a-select-option key="62" value="62">+62</a-select-option>
                  <a-select-option key="61" value="61">+61</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
            <a-form-item label="No. Whatsapp">
              <div class="confirmWa">
                <a-checkbox
                  v-decorator="[
                    'notif_wa',
                    {
                      valuePropName: 'checked',
                      initialValue: data.profile.notif_wa == '1' ? true : false,
                    },
                  ]"
                  @change="handleConfirmWA"
                >
                  Willing to receive notifications by WhatsApp ?
                </a-checkbox>
                <a-input
                  :hidden="!confirmWa"
                  autocomplete="off"
                  placeholder="081111234xxx"
                  v-decorator="[
                    'wa_number',
                    {
                      initialValue: data.profile.no_wa,
                      rules: [
                        {
                          validator: confirmWa ? validatePhone : false,
                        },
                      ],
                    },
                  ]"
                >
                  <a-select
                    :hidden="!confirmWa"
                    :slot="confirmWa ? 'addonBefore' : ''"
                    v-decorator="[
                      'wa_code',
                      {
                        initialValue:
                          data.profile.country_code_wa !== null
                            ? data.profile.country_code_wa
                            : '62',
                      },
                    ]"
                  >
                    <a-select-option key="62" value="62">+62</a-select-option>
                    <a-select-option key="61" value="61">+61</a-select-option>
                  </a-select>
                </a-input>
              </div>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-row :gutter="16">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Tempat Lahir">
                  <a-input
                    autocomplete="off"
                    v-decorator="[
                      'tempat_lahir',
                      {
                        rules: [{ required: true }],
                        initialValue: data.profile.tempat_lahir,
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-co :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Tanggal Lahir">
                  <a-date-picker
                    v-decorator="[
                      'tgl_lahir',
                      { rules: [{ required: true }], initialValue: tanggal_lahir },
                    ]"
                  />
                </a-form-item>
              </a-co>
            </a-row>
            <a-form-item label="Jenis Kelamin">
              <a-select
                :disabled="getAuth.divisi[0] !== 'HRD'"
                v-decorator="[
                  'gender',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.gender,
                  },
                ]"
                ref="fgender"
                @change="onStatus2"
              >
                <a-select-option key="pria" value="laki-laki"
                  >Laki - Laki</a-select-option
                >
                <a-select-option key="perempuan" value="perempuan"
                  >Perempuan</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="Status Perkawinan">
               <!-- getAuth.divisi[0] !== 'HRD' -->
              <a-select
              :disabled="getAuth.divisi[0] !== 'HRD'"
                @select="onStatus"
                v-decorator="[
                  'status_perkawinan',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.status_perkawinan,
                  },
                ]"
                ref="fmarital"
              >
                <a-select-option key="m" value="Kawin">Kawin</a-select-option>
                <a-select-option key="bm" value="Tidak Kawin"
                  >Tidak Kawin</a-select-option
                >
                <a-select-option key="ch" value="Cerai Hidup"
                  >Cerai Hidup</a-select-option
                >
                <a-select-option key="cm" value="Cerai Mati"
                  >Cerai Mati</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="Agama">
              <a-select
                v-decorator="[
                  'agama',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.agama,
                  },
                ]"
              >
                <a-select-option key="islam" value="islam"
                  >Islam</a-select-option
                >
                <a-select-option
                  key="kristen protestan"
                  value="Kristen protestan"
                  >Kristen Protestan</a-select-option
                >
                <a-select-option key="katolik" value="katolik"
                  >Katolik</a-select-option
                >
                <a-select-option key="hindu" value="hindu"
                  >Hindu</a-select-option
                >
                <a-select-option key="buddha" value="buddha"
                  >Buddha</a-select-option
                >
                <a-select-option key="kong hu cu" value="kong hu cu"
                  >Kong Hu Cu</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="E-mail Korporat">
              <a-input
                :disabled="getAuth.divisi[0] !== 'HRD'"
                autocomplete="off"
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'The input is not valid E-mail!',
                      },
                      { required: true },
                    ],
                    initialValue: data.profile.email,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="E-mail Pribadi">
              <!-- :disabled="getAuth.divisi[0] !== 'HRD'" -->
              <a-input
                
                autocomplete="off"
                v-decorator="[
                  'gmail',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'The input is not valid E-mail!',
                      },
                      { required: true },
                    ],
                    initialValue: data.profile.gmail,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Tanggungan">
              <!-- getAuth.divisi[0] !== 'HRD' -->
              <a-select
                 :disabled="getAuth.divisi[0] !== 'HRD'" 
                v-decorator="[
                  'tanggungan',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.tanggungan,
                  },
                ]"
              >
                <a-select-option
                  v-for="item in tanggungan"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";

export default {
  name: "profile-page",
  props: ["data"],
  data() {
    return {
      visible: false,
      btnLoading: false,
      confirmWa: false,
      tanggungan: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getMaster"]),
    tanggal_lahir() {
      return moment(this.data.profile.tanggal_lahir, this.getDefaultDateFormat);
    },
  },
  methods: {
    moment,
    formatNumberTelp() {
      let countryCode = this.data.profile.country_code_tlp
        ? "+" + this.data.profile.country_code_tlp
        : "+62";
      let no = this.data.profile.no_telp ? this.data.profile.no_telp : "-";
      if (no.substring(0, 1) === "0") {
        no = no.substring(1, no.length);
      }
      if (no !== "-") {
        no = countryCode + " " + no;
      }
      return no;
    },
    formatNumberWA() {
      let countryCode = this.data.profile.country_code_wa
        ? "+" + this.data.profile.country_code_wa
        : "+62";
      let no = this.data.profile.no_wa ? this.data.profile.no_wa : "-";
      if (no.substring(0, 1) === "0") {
        no = no.substring(1, no.length);
      }
      if (no !== "-") {
        no = countryCode + " " + no;
      }
      return no;
    },
    handleModalEdit() {
      this.visible = true;
      this.checkConfirm();
      this.onStatus(this.data.profile.status_perkawinan);
      this.form.setFieldsValue({ tanggungan: this.data.profile.tanggungan });
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) {
          if (values.notif_wa && err.wa_number.errors.length > 0) {
            this.displayMessage("format-wa-error");
            return;
          }

          this.displayMessage("form-warning");
          return;
        }

        this.confirmMessage("confirm-edit");
      });
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (values.wa_number !== null && values.wa_number.length > 12) {
          this.displayMessage("maxPhone");
        } else {
          const postProfile = {
            nik: values.nik,
            tlc: values.tlc,
            nama: values.nama,
            no_ktp: values.no_ktp,
            alamat: values.alamat,
            telpon: values.noTelp,
            country_code_tlp: values.noTelp_code,
            notif_wa: this.confirmWa ? "1" : "0",
            no_wa: this.confirmWa ? values.wa_number : null,
            country_code_wa: this.confirmWa ? values.wa_code : null,
            tempat_lahir: values.tempat_lahir,
            tgl_lahir: values.tgl_lahir.format(this.getStandartFormatDate),
            gender: values.gender,
            status_perkawinan: values.status_perkawinan,
            agama: values.agama,
            email: values.email,
            gmail: values.gmail,
            tanggungan: values.tanggungan,
          };

          axios({
            method: "post",
            url: this.$serviceUrl + "master_karyawan/edit_profile",
            processData: false,
            data: postProfile,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-edit");
              this.btnLoading = false;
              Event.$emit("fetching");
              this.handleCancel();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleConfirmWA(e) {
      this.confirmWa = e.target.checked;
    },
    checkConfirm() {
      if (this.data.profile.notif_wa == "1") {
        this.confirmWa = true;
      } else {
        this.confirmWa = false;
      }
    },
    validatePhone(rule, value, callback) {
      if (/^(\d)+$/.test(value)) {
        callback();
      } else {
        callback(new Error("Mobile number only digits"));
      }
    },
    onStatus(item) {
      this.form.setFieldsValue({ tanggungan: "" });
      let f_gender = this.$refs.fgender?this.$refs.fgender.value:null
        f_gender = f_gender ? f_gender : this.data.profile.gender
      
      if (f_gender.toLowerCase() == "perempuan") {
        this.tanggungan = this.getMaster.tanggungan
      }else if (item.toLowerCase() == "kawin") {
        this.tanggungan = this.getMaster.tanggungan.filter(
          (item) => item.status == "Kawin"
        );
      } else {
        this.tanggungan = this.getMaster.tanggungan.filter(
          (item) => item.status == "Tidak Kawin"
        );
      }
    },
    onStatus2(item) {
      this.form.setFieldsValue({ tanggungan: "" });
      let f_marital = this.$refs.fmarital?this.$refs.fmarital.value:""
        f_marital = f_marital ? f_marital : this.data.profile.status_perkawinan
      
      if (item.toLowerCase() == "perempuan") {
        this.tanggungan = this.getMaster.tanggungan
      }else if (f_marital.toLowerCase() == "kawin") {
        this.tanggungan = this.getMaster.tanggungan.filter(
          (item) => item.status == "Kawin"
        );
      } else {
        this.tanggungan = this.getMaster.tanggungan.filter(
          (item) => item.status == "Tidak Kawin"
        );
      }
    },
  },
  mounted() {
    Event.$on("confirmMessageEdit", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageEdit", this.submit);
  },
};
</script>

<style lang="less" scoped>
.confirmWa {
  border: 1px dashed orange;
  background-color: darken(white, 2);
  padding: 0 @padding;
  display: flex;
  align-items: center;
  flex-direction: column;

  > label {
    margin-left: -18px;
  }

  > .ant-input-group-wrapper {
    margin-bottom: @padding;
  }
}
</style>
